import React, { useState } from "react";
import { VerifyP2PSellerPayment } from "../../../pages";
import * as yup from "yup";
import { MimaToastUtil } from "../../../components";
import constant from "../../../utils/constant";
import { MoneyExController } from "../../../controllers";

const VerifyP2PSellerPaymentContainer = ({ closeModal, singleItem }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return yup.object().shape({
      amount: yup.string().required("Enter amount"),
      sellerPaymentDateTime: yup
        .string()
        .required("Enter seller payment date/time"),
      sellerStatus: yup.string().required("Select Status"),
    });
  };
  const statusData = [
    { key: "PAID", value: "PAID" },
    { key: "FALSE-PAYMENT", value: "FALSE-PAYMENT" },
  ];

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      amount: values.amount,
      sellerPaymentDateTime: values.sellerPaymentDateTime,
      sellerStatus: values.sellerStatus,
      moneyExOrderId: singleItem._id,
      note: values.note,
    };

    const { status, errorMessage } =
      await MoneyExController.verifyP2PSellerPayment(payload);
    if (status === constant.Success) {
      MimaToastUtil.success({ message: "Payment verified successfully" });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };
  return (
    <VerifyP2PSellerPayment
      closeModal={closeModal}
      singleItem={singleItem}
      statusData={statusData}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      loading={loading}
    />
  );
};

export default VerifyP2PSellerPaymentContainer;
